import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import FormGigItem from '../../shared/FormGigItem';
import { updateExtraFast } from '../../../actions/packages';
import { getPackageById } from '../../../reducers/packages';
import { formatDaysKey } from '../../../utils/packagesUtils';

import './style.scss';

class FakeRadio extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            checked: props.currentValue
        };

        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        const numValue = Number(e.target.value),
            { onChange } = this.props;

        this.setState({
            checked: numValue
        });

        onChange(numValue);
    }

    render() {
        const { packageId, id, baseDays, fasterDays, fasterPrice } = this.props;
        const { currencyConverter } = this.context;
        const { checked } = this.state;

        return (
            <div className="fake-radio-wrapper">
                <FormGigItem packageId={packageId} id={id} quantity={checked}/>
                <label className="fake-radio">
                    <input type="radio" value={0} checked={checked === 0} name={packageId} onChange={this.onChange}/>
                    <span className="radio-img"/>
                    <span>{baseDays} <I18n k={formatDaysKey(baseDays)}/></span>
                </label>
                <label className="fake-radio">
                    <input type="radio" value={1} checked={checked === 1} name={packageId} onChange={this.onChange}/>
                    <span className="radio-img"/>
                    <span>{fasterDays} <I18n k={formatDaysKey(fasterDays)}/></span>
                    <p className="faster-price">(+{currencyConverter.convert(fasterPrice)})</p>
                </label>
            </div>
        );
    }
}

const mapStateToProps = ({ packages }, ownProps) => {
    const packageData = getPackageById(packages, ownProps.packageId),
        { extraFast, duration } = packageData;

    return {
        packageId: ownProps.packageId,
        id: extraFast.id,
        baseDays: duration,
        fasterDays: extraFast.duration,
        fasterPrice: extraFast.price,
        currentValue: extraFast.currentValue
    };
};


const mapDispatchToProps = (dispatch, ownProps) => ({
    onChange: (numValue) => {
        dispatch(updateExtraFast({value: numValue, packageId:ownProps.packageId}));
    }
});

FakeRadio.propTypes = {
    baseDays: PropTypes.number,
    fasterDays: PropTypes.number,
    fasterPrice: PropTypes.number,
    onChange: PropTypes.func,
    currentValue: PropTypes.number
}.isRequired;

FakeRadio.defaultProps = {
    onChange: () => true,
    currentValue: 0
};

FakeRadio.contextTypes = {
    currencyConverter: PropTypes.object
};

export { FakeRadio };
export default connect(mapStateToProps, mapDispatchToProps)(FakeRadio);
